import { jpPushOptInEntrySchema } from '@shared/models/jp-push-opt-in'
import { z } from 'zod'

export const notificationEntityIdSchema = z.string().regex(/^[1-9]\d{0,9}$/)
export const jpNotificationAccountParamsSchema = z.object({
  p4Target: z.enum(['holding', 'new-inquiry', 'notification-settings']).optional(),
  n: z.literal('36').optional(),
  seq: jpPushOptInEntrySchema.shape.seq.optional(),
  ch: z.literal('email').optional(),
  subscribeMappId: z
    .string()
    .regex(/^[a-f0-9]{32}$/)
    .optional(),
})
export const jpNotificationLoginParamsSchema = jpNotificationAccountParamsSchema.extend({
  enterClassId: notificationEntityIdSchema.optional(),
})

export function buildNotificationAccountPath(input: unknown): string {
  const result = jpNotificationAccountParamsSchema.safeParse(input)
  if (!result.success) {
    return '/my-podo'
  }
  const { p4Target, subscribeMappId } = result.data
  if (p4Target === 'notification-settings') {
    const entry = jpPushOptInEntrySchema.safeParse(result.data)
    return '/my-podo/notification-settings' + (entry.success ? `?n=36&seq=${entry.data.seq}&ch=email` : '')
  }
  if (p4Target === 'holding' && subscribeMappId) {
    return `/podo/jp/membership/holding?subscribeMappId=${subscribeMappId}`
  }
  if (p4Target === 'new-inquiry') {
    return '/my-podo/customer-center/inquiries/new'
  }
  return '/my-podo'
}

export function buildNotificationReservationPath(input: unknown): string {
  const result = z.object({ enterClassId: notificationEntityIdSchema.optional() }).safeParse(input)
  return result.success && result.data.enterClassId
    ? `/reservation?enterClassId=${result.data.enterClassId}`
    : '/reservation'
}
